module.exports = __webpack_public_path__ + "static/media/ppt.4b993c7c.png";